import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';
import LiveChallengeSidebar from './LiveChallengeSidebar';
import LiveChallengeContent from './LiveChallengeContent';

const STEPS = [
  { id: 1, route: 'nome', text: 'Defina o título, tema e o tempo de cada questão.' },
  { id: 2, route: 'questoes', text: 'Adicione as questões com alternativas e respostas corretas.' }
];

export default function CreateLiveChallenge() {
  const { step = 'nome', id } = useParams();
  const [currentStep, setCurrentStep] = useState(1);

  return (
    <Dashboard>
      <LiveChallengeSidebar
        steps={STEPS}
        currentStep={currentStep}
      />

      <DashboardContent viewMode="create">
        <LiveChallengeContent
          step={step}
          id={id}
          setCurrentStep={setCurrentStep}
        />
      </DashboardContent>
    </Dashboard>
  );
}
